<template>
    <form @submit.prevent="handleSubmit" id="company_create_form" enctype="multipart/form-data">

        <!-- Company Name -->
        <div class="mb-4">
            <label class="form-label form-label-thin">
                Company Name <span class="text-danger">*</span>
            </label>
            <input type="text" class="form-control form-control-thin" id="name" name="name" ref="name"
                v-model="form.name" placeholder="Company Name" />
        </div>

        <!-- Contact Person -->
        <div class="row">
            <div class="col-md-6 mb-4">
                <label class="form-label form-label-thin">
                    First Name <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control form-control-thin" id="first_name" name="first_name"
                    ref="first_name" v-model="form.first_name" placeholder="First Name" />
            </div>

            <div class="col-md-6 mb-4">
                <label class="form-label form-label-thin">
                    Last Name <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control form-control-thin" id="last_name" name="last_name"
                    ref="last_name" v-model="form.last_name" placeholder="Last Name" />
            </div>
        </div>

        <!-- Email -->
        <div class="mb-4">
            <label class="form-label form-label-thin">
                Email <span class="text-danger">*</span>
            </label>
            <input type="email" class="form-control form-control-thin" id="email" name="email" ref="email"
                v-model="form.email" placeholder="company@example.com" />
        </div>
        <div class="mb-4">
            <label class="form-label form-label-thin">Phone</label>
            <input type="text" class="form-control form-control-thin" id="phone" name="phone" ref="phone"
                v-model="form.phone" placeholder="Phone Number" />
        </div>
        <div class="row mb-4">
            <div class="col-6">
                <label class="form-label form-label-thin">Point of Contact 1</label>
                <input type="text" class="form-control form-control-thin" id="poc1" name="poc1" ref="poc1"
                    v-model="form.poc1" placeholder="POC 1 Name" />
            </div>
            <div class="col-6">
                <label class="form-label form-label-thin">Point of Contact 2</label>
                <input type="text" class="form-control form-control-thin" id="poc2" name="poc2" ref="poc2"
                    v-model="form.poc2" placeholder="POC 2 Name" />
            </div>
        </div>

        <!-- Address -->
        <div class="mb-4">
            <label class="form-label form-label-thin">Address</label>
            <input type="text" class="form-control form-control-thin" v-model="form.address" id="address" ref="address"
                name="address" placeholder="Street / Building" />
        </div>

        <!-- Country & City side by side -->
        <div class="row mb-4">
            <div class="col-6">
                <label class="form-label form-label-thin">Country</label>
                <input type="text" class="form-control form-control-thin" v-model="form.country" id="country"
                    ref="country" name="country" placeholder="Country" />
            </div>
            <div class="col-6">
                <label class="form-label form-label-thin">City</label>
                <input type="text" class="form-control form-control-thin" v-model="form.city" placeholder="City"
                    id="city" name="city" ref="city" />
            </div>
        </div>

        <!-- Logo -->
        <div class="mb-4">
            <label class="form-label form-label-thin">Logo</label>
            <input type="file" class="form-control form-control-thin" @change="handleLogoChange" accept="image/*" />
            <div v-if="form.logo_preview" class="mt-2">
                <img :src="form.logo_preview" alt="Logo Preview"
                    style="max-width: 120px; max-height: 120px; border-radius: 8px; object-fit: cover;" />
            </div>
        </div>

        <!-- Actions -->
        <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="close">
                <i class="fa fa-times"></i> Cancel
            </button>
            <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn"
                :disabled="submitting">
                <i class="fa fa-save"></i>
                {{ submitting ? 'Creating...' : 'Create Company' }}
            </button>
        </div>

    </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
    name: 'CreateCompany',

    inject: ['formGuard'],

    emits: ['created', 'close'],

    data() {
        return {
            form: {
                name: '',
                email: '',
                first_name: '',
                last_name: '',
                phone: '',
                poc1: '',
                poc2: '',
                address: '',
                country: '',
                city: '',
                status: 'active',
                logo: null,
                logo_preview: null,
            },
            submitting: false,
        }
    },

    watch: {
        form: {
            deep: true,
            handler() {
                this.formGuard.markDirty()
            },
        },
    },

    methods: {

        handleLogoChange(event) {
            const file = event.target.files[0]
            if (!file) return
            this.form.logo = file
            const reader = new FileReader()
            reader.onload = (e) => { this.form.logo_preview = e.target.result }
            reader.readAsDataURL(file)
        },

        async handleSubmit() {
            this.submitting = true

            try {
                const fd = new FormData()

                const scalars = ['name', 'email', 'phone', 'poc1', 'poc2', 'address', 'country', 'city', 'status','first_name','last_name']
                scalars.forEach(key => {
                    if (this.form[key] !== null && this.form[key] !== '') {
                        fd.append(key, this.form[key])
                    }
                })

                if (this.form.logo) {
                    fd.append('logo', this.form.logo)
                }

                const result = await form_api_submit({
                    url: 'companies/create',
                    method: 'POST',
                    data: fd,
                    curr_form_id: '#company_create_form',
                })

                if (result.success) {
                    this.formGuard.markClean()
                    this.$emit('created')
                    this.$emit('close')
                }
            } finally {
                this.submitting = false
            }
        },

        close() {
            this.formGuard.requestClose()
        },

        resetForm() {
            this.form = {
                name: '',
                email: '',
                phone: '',
                poc1: '',
                poc2: '',
                address: '',
                country: '',
                city: '',
                status: 'active',
                logo: null,
                logo_preview: null,
            }
        },
    },
}
</script>

<style scoped>
.modal-footer {
    padding: 12px 0 0 0;
    border-top: none;
    gap: 8px;
}
</style>